<h2 mat-dialog-title>Forgot Password</h2>
<span mat-dialog-close class="btn-mat-dialog-close">
    <img src="assets/images/close-icon-gray.svg" alt="Close" title="Close" />
</span>
<mat-dialog-content>
    <p>
        Lost your password? Please enter your registered email address. You will
        receive a link to create a new password via email.
    </p>
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
            <label for="email">Registered Email address *</label>

            <mat-form-field appearance="fill" class="full-width custom-form-field">
                <input matInput placeholder="Enter e-mail address" formControlName="email" id="email" type="email" />
            </mat-form-field>

            <div class="error" *ngIf="
          forgotPasswordForm.controls.email.touched &&
          forgotPasswordForm.controls.email.invalid
        ">
                <span *ngIf="forgotPasswordForm.controls.email.hasError('required')">Email is required</span>
                <span *ngIf="forgotPasswordForm.controls.email.hasError('email')">Enter a valid email address</span>
            </div>
        </div>

        <button class="full-width" mat-raised-button color="primary" type="submit"
            [disabled]="forgotPasswordForm.invalid">
            Reset Password
        </button>

        <div class="row">
            <div class="col-12 text-center">
                <button mat-button type="button" mat-dialog-close>Back to Login</button>
            </div>
        </div>
    </form>
</mat-dialog-content>